import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useCallback, useContext } from 'react';

const SidebarContext = createContext(null);
function AppSidebarProvider({ children, initialState = {} }) {
    const [state, setState] = useState({
        baseItems: [],
        groups: [],
        settings: {
            userSettings: { enabled: true },
            organizationSettings: { enabled: true },
        },
        ...initialState,
    });
    const setBaseItems = useCallback((items) => {
        setState(prev => ({ ...prev, baseItems: items }));
    }, []);
    const setGroups = useCallback((groups) => {
        setState(prev => ({ ...prev, groups }));
    }, []);
    const addGroup = useCallback((group) => {
        setState(prev => ({
            ...prev,
            groups: [...prev.groups.filter(g => g.label !== group.label), group],
        }));
    }, []);
    const removeGroup = useCallback((label) => {
        setState(prev => ({
            ...prev,
            groups: prev.groups.filter(g => g.label !== label),
        }));
    }, []);
    const setSettings = useCallback((settings) => {
        setState(prev => ({ ...prev, settings }));
    }, []);
    const setHeader = useCallback((header) => {
        setState(prev => ({ ...prev, header }));
    }, []);
    const setFooter = useCallback((footer) => {
        setState(prev => ({ ...prev, footer }));
    }, []);
    return (jsx(SidebarContext.Provider, { value: {
            state,
            setBaseItems,
            setGroups,
            addGroup,
            removeGroup,
            setSettings,
            setHeader,
            setFooter,
        }, children: children }));
}
function useSidebarContext() {
    const context = useContext(SidebarContext);
    if (!context) {
        throw new Error('useSidebar must be used within a SidebarProvider');
    }
    return context;
}

export { AppSidebarProvider, useSidebarContext };
//# sourceMappingURL=SidebarContext.js.map
